import { connect } from 'react-redux';
import { push } from 'react-router-redux/lib/actions';
import { STREAM_ROUTER_ROOT } from '../constants';
import CreateNewComponent from './StreamNew';
import {streamAction} from '../../../../actions/stream/customStream';

// new way of actions. Has to have less memory in use;
let CRUDActions = streamAction;

export default connect(
  ({customStream: {loadingItem}}) => ({
    title: 'Create Stream',
    loading: loadingItem
  }),
  dispatch => ({
    fetch: async () => await dispatch(CRUDActions.createModel()),
    goIndex: async () => await dispatch(push(STREAM_ROUTER_ROOT))
  })
)(CreateNewComponent)





// WEBPACK FOOTER //
// ./src/components/Stream/CustomStream/StreamNew/index.js